import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '@mui/material';

import MDBox from 'components/MDBox';

import AsyncDropdown from '../../../components/AsyncDropdown/AsyncDropdown';
import DownloadMenu from '../../../components/DownloadMenu/DownloadMenu';
import AsyncMultiDropdown from './AsyncMultiDropdown';

const TransactionFilters = ({
  setUserId,
  setPropertyId,
  setFilterObj,
  onDownloadCSV,
  onDownloadXLSX,
}) => {
  const onUserSelect = (value) => {
    setUserId(value?.userId);
  };

  const onPropertySelect = (value) => {
    setPropertyId(value?.id);
  };

  const onPropertyTypeSelect = (value) => {
    setFilterObj({
      filterBy: value?.length > 0 ? 'propertyType' : '',
      filterValues:
        value?.length > 0 ? [...value.map((val) => val?.propertyTypeId)] : [],
    });
  };

  const onDownloadCSVClick = () => {
    try {
      onDownloadCSV();
    } catch (error) {
      console.log({ error });
    }
  };

  const onDownloadXLSXClick = () => {
    try {
      onDownloadXLSX();
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <MDBox pt={3}>
      <Grid container px={4} spacing={4}>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <AsyncMultiDropdown onChange={onPropertyTypeSelect} />
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <AsyncDropdown
            dropdownId="userName"
            optionLabel="name"
            optionValue="userId"
            inputLabel="User"
            onChange={onUserSelect}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <AsyncDropdown
            dropdownId="propertyName"
            optionLabel="name"
            optionValue="id"
            inputLabel="Property"
            onChange={onPropertySelect}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <DownloadMenu
            onDownloadCSVClick={onDownloadCSVClick}
            onDownloadXLSXClick={onDownloadXLSXClick}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
};

TransactionFilters.propTypes = {
  setUserId: PropTypes.func,
  setPropertyId: PropTypes.func,
  setFilterObj: PropTypes.func,
  onDownloadCSV: PropTypes.func,
  onDownloadXLSX: PropTypes.func,
};

TransactionFilters.defaultProps = {
  setUserId: () => {},
  setPropertyId: () => {},
  setFilterObj: () => {},
  onDownloadCSV: () => {},
  onDownloadXLSX: () => {},
};

export default TransactionFilters;
